import { RoleModel } from '../../document-management-details/document-management/document-management.model';
export class ExitFormModel {
    anotherPosition: boolean;
    answerOfQuestion1: string;
    answerOfQuestion10: string;
    answerOfQuestion11: string;
    answerOfQuestion12: string;
    answerOfQuestion13: string;
    answerOfQuestion2: string;
    answerOfQuestion3: string;
    answerOfQuestion4: string;
    answerOfQuestion5: string;
    answerOfQuestion6: string;
    answerOfQuestion7: string;
    answerOfQuestion8: string;
    answerOfQuestion9: string;
    attendance: boolean;
    dissatisfication: boolean;
    eligibleForRehire: boolean;
    employeeComments: string;
    employeeSignature: boolean;
    employeeSignatureDate: any;
    forBetterProspects: string;
    furtherStudies: boolean;
    interviewerComments: string;
    interviewerSignature: boolean;
    interviewerSignatureDate: any;
    jobCode: string;
    jobTitle: string;
    layOff: boolean;
    otherInvoluntary: boolean;
    otherVoluntary: string;
    personalReason: boolean;
    positionEliminated: boolean;
    relocation: boolean;
    reorganization: boolean;
    retirement: boolean;
    separationDate: any;
    violationOfFirmPolicy: boolean;
    otherInvoluntaryDesc: string;
    otherVoluntaryDesc: string;
    user: UserModel;
    partner: PartnerModel;
}
export class UserModel {
    id: number;
    firstName: string;
    lastName: string;
    middleName: string;
    droles: DRoleModel[];
}

export class DRoleModel {
    id: number;
    name: string;
}

export class PartnerModel {
    id: number;
    firstName: string;
    lastName: string;
    middleName: string;
}